import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be671bd0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=be671bd0&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=be671bd0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be671bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be671bd0')) {
      api.createRecord('be671bd0', component.options)
    } else {
      api.reload('be671bd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be671bd0&scoped=true", function () {
      api.rerender('be671bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/ColorPicker/index.vue"
export default component.exports